import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BreadcrumbService } from '@tsin-core/services/common/breadcrumb.service';
import { FooterComponent } from '@tsin-shared/components/footer/footer.component';
import { MainHeaderComponent } from '@tsin-shared/components/main-header/main-header.component';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';

@Component({
  selector: 'app-user',
  imports: [
    MainHeaderComponent,
    RouterModule,
    CommonModule,
    MainHeaderComponent,
    FooterComponent,
    BreadcrumbModule,
  ],
  templateUrl: './user.layout.html',
  styleUrl: './user.layout.css'
})
export class UserLayout {
  private breadcrumbSvc = inject(BreadcrumbService);
  private translate = inject(TranslateService);

  readonly breadcrumbs$ = this.breadcrumbSvc.breadcrumbs$;

  /** Home crumb is per-layout — applicants go back to their own home, not
   *  management's. Re-read on language change since the label is translated. */
  readonly breadcrumbHome = signal<MenuItem>(this.homeCrumb());

  constructor() {
    this.translate.onLangChange.subscribe(() => this.breadcrumbHome.set(this.homeCrumb()));
  }

  private homeCrumb(): MenuItem {
    return { icon: 'pi pi-home', label: this.translate.instant('HOME.LIST.BREADCRUMB_HOME'), routerLink: '/user/home' };
  }
}
